/* lystia-header.js - поведінка Header (T-E2-13, parity/shell.md §2). Підключення: <script src defer> із sections/header.liquid.
   Лічильник кошика оновлює lystia-cart.js ([data-cart-count]); тут: aria-label кошика, іконка/aria Улюбленого, пошук і кошик D -> overlay.
   Без перерендеру: оновлення на місці (фокус не губиться). */
(function () {
  'use strict';

  var MQ = window.matchMedia('(min-width: 1024px)');
  var isDesktop = function () { return document.lystia ? document.lystia.device() === 'desktop' : MQ.matches; };

  /* uk-множина (1 / 2-4 / інше, 11-14 -> many) - ті самі правила, що snippets/plural.liquid */
  function pluralForm(n) {
    var a = Math.abs(n), m100 = a % 100, m10 = a % 10;
    if (m100 >= 11 && m100 <= 14) return 'many';
    if (m10 === 1) return 'one';
    if (m10 >= 2 && m10 <= 4) return 'few';
    return 'many';
  }

  function overlay(name) {
    var o = document.lystiaOverlay;
    return o && o.has(name) ? o : null;
  }

  class LystiaHeader {
    constructor(root) {
      this.root = root;
      this.search = root.querySelector('[data-header-search]');
      this.fav = root.querySelector('[data-header-fav]');
      this.cart = root.querySelector('[data-header-cart]');
      this.bind();
      this.updateFav();
    }

    bind() {
      var self = this;
      if (this.search) this.search.addEventListener('click', function (e) {
        var o = overlay('search');
        if (isDesktop() && o) { e.preventDefault(); o.open('search'); }
      });
      if (this.cart) this.cart.addEventListener('click', function (e) {
        var o = overlay('cart');
        if (o) { e.preventDefault(); o.open('cart'); }
      });
      this.onCart = function (e) {
        var cart = e && e.detail && e.detail.cart;
        if (cart) self.updateCart(cart.item_count);
      };
      this.onFav = function () { self.updateFav(); };
      document.addEventListener('cart:change', this.onCart);
      document.addEventListener('fav:change', this.onFav);
      window.addEventListener('storage', this.onFav);
      window.addEventListener('pageshow', this.onFav);
    }

    updateCart(n) {
      if (!this.cart) return;
      var d = this.cart.dataset;
      var items = d['plural' + pluralForm(n).charAt(0).toUpperCase() + pluralForm(n).slice(1)] || '';
      this.cart.setAttribute('aria-label', (d.label || '').replace('%items', items.replace('%n', String(n))));
    }

    updateFav() {
      if (!this.fav) return;
      var svc = window.LystiaFavorites;
      var n = svc ? svc.count() : 0;
      var on = this.fav.querySelector('[data-fav-on]');
      var off = this.fav.querySelector('[data-fav-off]');
      if (on) on.hidden = n === 0;
      if (off) off.hidden = n > 0;
      this.fav.setAttribute('aria-label', n ? (this.fav.dataset.labelCount || '').replace('%n', String(n)) : (this.fav.dataset.label || ''));
    }
  }

  var seen = new WeakSet();
  function init(scope) {
    (scope || document).querySelectorAll('[data-lystia-header]').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      new LystiaHeader(el);
    });
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
